
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class SupportDialog extends Serenity.EntityDialog<SupportRow, any> {
        protected getFormKey() { return SupportForm.formKey; }
        protected getIdProperty() { return SupportRow.idProperty; }
        protected getLocalTextPrefix() { return SupportRow.localTextPrefix; }
        protected getNameProperty() { return SupportRow.nameProperty; }
        protected getService() { return SupportService.baseUrl; }
        protected getDeletePermission() { return SupportRow.deletePermission; }
        protected getInsertPermission() { return SupportRow.insertPermission; }
        protected getUpdatePermission() { return SupportRow.updatePermission; }

        protected form = new SupportForm(this.idPrefix);

    }
}